"use client";
import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import NextLink from "next/link";
const ZaynLanguagesSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        py: { xs: 5, sm: 6, md: 4 },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="md">
        <Typography
          sx={{
            fontSize: { xs: "11px", sm: "12px" },
            fontWeight: 600,
            color: "#7A2BF5",
            textTransform: "uppercase",
            letterSpacing: "1px",
            fontFamily: "var(--font-outfit)",
            textAlign: "center",
            mb: { xs: 1.5, sm: 2 },
            mt:{ xs: 0, sm: 5 }
          }}
        >
          {t("zaynLanguages.label")}
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "22px", sm: "26px", md: "38px" },
            fontWeight: 700,
            lineHeight: 1.35,
            color: "#14122B",
            fontFamily: "var(--font-plusjakarta)",
            textAlign: "center",
            mb: { xs: 2, sm: 2.5, md: 3 },
          }}
        >
          {t("zaynLanguages.heading.main")}{" "}
          <Box component="span" sx={{ color: "#7A2BF5" }}>
            {t("zaynLanguages.heading.highlight")}
          </Box>
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "13px", sm: "15px" },
            color: "#55556E",
            lineHeight: 1.8,
            fontWeight: 400,
            fontFamily: "var(--font-outfit)",
            textAlign: "center",
            maxWidth: 770,
            mx: "auto",
            mb: { xs: 3, sm: 3.5, md: 4 },
          }}
        >
          {t("zaynLanguages.description")}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <NextLink
            href="/free-trial-of-ai-recruiting-tool"
            passHref
            legacyBehavior
          >
            <Button
              component="a"
              sx={{
                bgcolor: "#7A2BF5",
                color: "#fff",
                px: { xs: 3, sm: 3 },
                py: { xs: 1.2, sm: 1.4 },
                borderRadius: "50px",
                textTransform: "none",
                fontSize: { xs: "14px", sm: "16px" },
                fontWeight: 500,
                fontFamily: "var(--font-outfit)",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  bgcolor: "#5F1FC7",
                  transform: "scale(1.03)",
                },
              }}
            >
              {t("zaynLanguages.cta")}
            </Button>
          </NextLink>
        </Box>
      </Container>
    </Box>
  );
};

export default ZaynLanguagesSection;